$(document).ready(function () {

    /*
    * Change the currency being used.
    */
    $(".currencySelector a").on('click', function(e) {



         var id = $(this).attr('id');

         var currency = id.replace("currency_", "");


         $(".multiprice span").hide();
         $(".multiprice ." + currency).show();


         $("#selected_currency").html(currency);

         setCookie('currency', currency, 100);

         return false;

        });


        function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
    }


});